import { render, staticRenderFns } from "./systemDescription.vue?vue&type=template&id=79495e4e&scoped=true"
import script from "./systemDescription.vue?vue&type=script&lang=js"
export * from "./systemDescription.vue?vue&type=script&lang=js"
import style0 from "./systemDescription.vue?vue&type=style&index=0&id=79495e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79495e4e",
  null
  
)

export default component.exports